// Billing Subscription Upgrade
export const BILLING_SUBSCRIPTION_UPGRADE_REQUEST = 'BILLING_SUBSCRIPTION_UPGRADE_REQUEST';
export const BILLING_SUBSCRIPTION_UPGRADE_DONE = 'BILLING_SUBSCRIPTION_UPGRADE_DONE';
export const BILLING_SUBSCRIPTION_UPGRADE_FAILED = 'BILLING_SUBSCRIPTION_UPGRADE_FAILED';
export const BILLING_SUBSCRIPTION_UPGRADE_RESET = 'BILLING_SUBSCRIPTION_UPGRADE_RESET';